import React, { memo } from "react";
import { SkeletonText, Link as ChakraLink, Tag } from "@chakra-ui/react";
import { Table, Tbody, Td, Th, Tr, Thead } from "@chakra-ui/table";
import { CherryHubAdminApi } from "../../api/adminApiModels";
import { Link } from "react-router-dom";
import { PreviewButton } from "../Utilities/PreviewButton";

interface MembersTableProps {
  members: CherryHubAdminApi.MemberSummaryItem[] | null;
  isLoading: boolean;
  debouncedQuery: string;
}

export const MembersTable = memo(
  ({ members, isLoading, debouncedQuery }: MembersTableProps) => {
    const skeletonLoadingTable = (rows: number = 12) => {
      return (
        <Tr>
          <Td width="22%">
            <SkeletonText noOfLines={rows} spacing="4" width="100%" />
          </Td>
          <Td width="8%">
            <SkeletonText noOfLines={rows} spacing="4" width="100%" />
          </Td>
          <Td width="53.5%">
            <SkeletonText noOfLines={rows} spacing="4" width="100%" />
          </Td>
          <Td width="7%">
            <SkeletonText noOfLines={rows} spacing="4" width="100%" />
          </Td>
          <Td width="9.5%">
            <SkeletonText noOfLines={rows} spacing="4" width="100%" />
          </Td>
        </Tr>
      );
    };

    return (
      <Table size="sm">
        <Thead>
          <Tr>
            <Th>Business</Th>
            <Th whiteSpace="nowrap">Membership #</Th>
            <Th>Name</Th>
            <Th>Financial</Th>
            <Th>Status</Th>
          </Tr>
        </Thead>
        <Tbody>
          {isLoading && skeletonLoadingTable()}
          {!isLoading && members && members.length === 0 && (
            <Tr>
              <Td colSpan={4} textAlign="center">
                {debouncedQuery === ""
                  ? "No members found."
                  : `No members found matching query '${debouncedQuery}'`}
              </Td>
            </Tr>
          )}
          {members &&
            members.length > 0 &&
            !isLoading &&
            members.map((member) => (
              <Tr key={member.Meta?.Id}>
                <Td w="0.1%">
                  <PreviewButton
                    url={`/admin/businesses/${member.BusinessId}`}
                    linkProps={{ target: "_self" }}
                    hover={true}
                  >
                    {member.BusinessName}
                  </PreviewButton>
                </Td>
                <Td w="0.1%" whiteSpace="nowrap">
                  <ChakraLink
                    as={Link}
                    to={`/admin/members/${member.Meta?.Id}`}
                  >
                    {member.MembershipNumber}
                  </ChakraLink>
                </Td>
                <Td title="View member">
                  <ChakraLink
                    as={Link}
                    to={`/admin/members/${member.Meta?.Id}`}
                  >
                    {member.DisplayName}
                  </ChakraLink>
                </Td>
                <Td w="0.1%">
                  <Tag
                    size="sm"
                    bgColor={member.Financial ? "" : "cherryButton.500"}
                    color={member.Financial ? "" : "white"}
                  >
                    {member.Financial ? "Financial" : "Unfinancial"}
                  </Tag>
                </Td>
                <Td w="0.1%">{member.Status}</Td>
              </Tr>
            ))}
        </Tbody>
      </Table>
    );
  }
);
